import { Capacitor } from '@capacitor/core'

/**
 * Function to make it handy to get current platform info
 * NOTE: This is no 'real' composable since it doesn't handle stateful logic
 * Yet it is easier to use it in a composable-like way
 */
export function usePlatformInfo() {
  const isIos = Capacitor.getPlatform() === 'ios'
  const isAndroid = Capacitor.getPlatform() === 'android'
  const isWeb = Capacitor.getPlatform() === 'web'
  const isMobile = !isWeb
  const isTablet = isTabletUserAgent()

  return { isIos, isAndroid, isWeb, isMobile, isTablet }
}

/**
 * Detects if the device is a tablet based on user agent patterns.
 * Uses comprehensive regex patterns to identify various tablet devices.
 */
function isTabletUserAgent(): boolean {
  const userAgent = navigator.userAgent.toLowerCase()

  // iPad detection (covers all iPad models including iPad Pro)
  const isiPad =
    /ipad/.test(userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)

  // Android tablet detection
  const isAndroidTablet = /android/.test(userAgent) && !/mobile/.test(userAgent)

  // Windows tablet detection
  const isWindowsTablet =
    /windows/.test(userAgent) &&
    /touch/.test(userAgent) &&
    !/phone/.test(userAgent)

  // Additional tablet patterns
  const isTabletPattern =
    /tablet|ipad|playbook|silk|(puffin(?!.*(IP|AP|WP)))/.test(userAgent)

  // Kindle tablets
  const isKindle =
    /kindle|kfapwi|kfapwa|kfarwi|kfaswi|kfthwi|kfthwa|kfapwi|kfapwa/.test(
      userAgent,
    )

  return (
    isiPad || isAndroidTablet || isWindowsTablet || isTabletPattern || isKindle
  )
}
